module.exports = __webpack_public_path__ + "static/img/hexinyoushi_bj_image@2x.40040457.jpg";